import { render, staticRenderFns } from "./stockout_submit.vue?vue&type=template&id=492c81aa&scoped=true&"
import script from "./stockout_submit.vue?vue&type=script&lang=js&"
export * from "./stockout_submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c81aa",
  null
  
)

export default component.exports